import React from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import Modal from 'common/components/modal';
import ModalBody from 'common/components/modal-body';
import ModalFooter from 'common/components/modal-footer';
import ModalHeader from 'common/components/modal-header';
import {t} from 'common/utils/translation-util';
import * as ModalType from 'storyboard/constants/modal-type';
import './index.scss';

export default class StoryboardLogoModal extends React.Component {
  static propTypes = {
    addLogo: PropTypes.func,
    closeModal: PropTypes.func,
    data: PropTypes.object.isRequired,
    deleteLogo: PropTypes.func,
    isOpen: PropTypes.bool,
    title: PropTypes.string,
    type: PropTypes.string,
  };

  static defaultProps = {
    addLogo: () => {},
    closeModal: () => {},
    deleteLogo: () => {},
    isOpen: false,
    title: '',
    type: '',
  };

  constructor() {
    super();
    this.state = {};
    this.handleAdd = this.handleAdd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDrop = this.handleDrop.bind(this);
  }

  getSaveHandler(type, logo, handleAdd, handleDelete) {
    if (type === ModalType.ADD_LOGO) {
      return logo ? handleAdd : null;
    }
    if (type === ModalType.DELETE_LOGO) {
      return handleDelete;
    }
  }

  deletePreview() {
    this.setState({
      logo: null,
    });
  }

  render() {
    const handleSave = this.getSaveHandler(
      this.props.type,
      this.state.logo,
      this.handleAdd,
      this.handleDelete,
    );

    let buttonProps = {
      children: t('Save'),
      type: 'green',
    };

    if (this.props.type === ModalType.DELETE_LOGO) {
      buttonProps = {
        children: t('Delete'),
        type: 'red',
        withIcon: true,
      };
    }

    return (
      <Modal className={'StoryboardLogoModal'} isOpen={this.props.isOpen}>
        <ModalHeader>{this.props.title}</ModalHeader>

        <ModalBody>
          <div>
            {this.props.type === ModalType.ADD_LOGO ? (
              <Dropzone
                className={'StoryboardLogoModal--dropzone'}
                multiple={false}
                onDrop={this.handleDrop}>
                {this.state.logo ? (
                  <img
                    height={'90%'}
                    src={this.state.logo.preview}
                    width={'auto'}
                  />
                ) : (
                  <div>
                    {t(
                      'Drag a logo image here, or click here to browse for one.',
                    )}
                  </div>
                )}
              </Dropzone>
            ) : null}

            {this.props.type === ModalType.DELETE_LOGO ? (
              <div>{t('Are you sure you want to delete this logo?')}</div>
            ) : null}
          </div>
        </ModalBody>

        <ModalFooter
          onCancel={this.handleCancel}
          onSave={handleSave}
          saveButtonProps={buttonProps}
        />
      </Modal>
    );
  }

  handleAdd() {
    this.props.closeModal();
    this.props.addLogo(this.state.logo);
    this.deletePreview();
  }

  handleCancel() {
    this.props.closeModal();
    this.deletePreview();
  }

  handleDelete() {
    const {logo} = this.props.data || {};
    this.props.closeModal();
    this.props.deleteLogo(logo);
    this.deletePreview();
  }

  handleDrop(files) {
    this.setState({
      logo: files.shift(),
    });
  }
}
